/**
 * CANONICAL MODULE — app-platform/shared/syncStatus.ts
 *
 * Copied byte-for-byte into every app (`src/lib/syncStatus.ts`). Imports NOTHING, on purpose: a sync
 * pill lives in an app's entry chunk, and importing `syncStatusWithConflicts` from `conflictChooser.ts`
 * dragged that file and `conflictPolicy.ts` into it (about +10 KB, found in the inkling W11 pilot).
 * `conflictChooser.ts` re-exports it, so existing imports keep working; a pill should import from here.
 *
 * **Fix bugs HERE, then copy outward. Never edit an app's copy in place.**
 */

/** With any open record the status is `'conflict'`, never `'synced'`. Errors and offline still show. */
export function syncStatusWithConflicts<S extends string>(base: S, openConflicts: number): S | 'conflict' {
  if (openConflicts <= 0) return base
  return base === 'error' || base === 'offline' ? base : 'conflict'
}
